import React, { useEffect, useState } from 'react'

import { useProfessors, useStudents } from '../../../../context'
import { Student } from '../../../../types'
import { TableContainer } from '../../../lists/styles'

const ProfessorSharedProccess = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  professorId,
  professorName,
}: {
  professorId: string
  professorName: string
}) => {
  const { studentsList } = useStudents()
  const { professorsList } = useProfessors()

  const [sharedProccess, setSharedProccess] = useState<Student[] | null>(null)

  console.log(professorsList, professorsList)

  useEffect(() => {
    if (studentsList) {
      const hasMoreThanOneProfessor = studentsList.filter(
        (student) =>
          student.professors.length > 1 &&
          student.professors.some((professor) => professor === professorName),
      )
      setSharedProccess(hasMoreThanOneProfessor)
    }
  }, [studentsList])

  const professors = (std: Student) => {
    return [...std.professors]
      .map((name) => {
        const isActive =
          professorsList?.some(
            (professor) => `${professor.name} ${professor.lastname}` === name,
          ) ?? false
        return { name, isActive }
      })
      .sort((a, b) => {
        // Activos primero, inactivos al final
        if (a.isActive && !b.isActive) return -1
        if (!a.isActive && b.isActive) return 1
        return 0
      })
      .map(({ name, isActive }, i) => (
        <span
          key={i}
          className={!isActive ? 'inactive' : undefined}
          style={{ textTransform: 'capitalize' }}
        >
          {name}
        </span>
      ))
  }

  return (
    <TableContainer>
      {sharedProccess &&
        sharedProccess.map((std, i) => {
          return (
            <div
              key={i}
              className="t-row"
              style={{ justifyContent: 'space-between' }}
            >
              <div className="t-student with-image">
                <div
                  className="profile-image"
                  style={{
                    backgroundImage: `url(${std.image && std.image.length > 0 ? std.image : '/assets/profile.png'})`,
                  }}
                ></div>
                {std.name} {std.lastname}
              </div>
              <div
                className="t-professors"
                style={{
                  width: '50%',
                  flex: 'none',
                  gap: '20px',
                  justifyContent: 'flex-start',
                }}
              >
                Profesores:
                {professors(std)}
              </div>
            </div>
          )
        })}
    </TableContainer>
  )
}

export default ProfessorSharedProccess
